<template>
  <div class="power-curve">
    <div class="curve-header">
      <img src="@/assets/images/station-monitor/image_54.png" width="18" height="18" />
      <span>功率曲线</span>
    </div>
     <VChart class="curve-chart" :option="opt" autoresize />
  </div>
</template>

<script setup>
import { watch, computed, shallowRef } from 'vue'
import * as api from '@/api/device/pv'
import { Option } from './chart-opt';
import VChart from 'vue-echarts'

const props = defineProps({
  stationId: {
    type: [String, Number],
    default: '',
  },
})

const statisticsData = shallowRef([])

async function fetchPvDataStatistics(sid) {
  const res = await api.getPvDataStatistics(sid);
  statisticsData.value = res.data || [];
}

const opt = computed(() => {
  return Option(statisticsData.value);
});

watch(() => props.stationId, (sid) => fetchPvDataStatistics(sid), {immediate: true})
</script>

<style scoped lang="scss">
.power-curve {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 20px;
  padding: 16px 22px;
  min-width: 0;
  font-family: 'HarmonyOS Sans SC', sans-serif;
}

.curve-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 500;
  color: #2e2e2e;
  margin-bottom: 8px;
}

.curve-chart {
  flex: 1;
  width: 100%;
  min-height: 460px;
}
</style>
